var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.909091,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 5V5.45455H17H19C19.849 5.45455 20.5455 6.15104 20.5455 7V8C20.5455 10.3134 18.8035 12.2066 16.5534 12.489L16.2927 12.5217L16.1909 12.764C15.6184 14.1272 14.3903 15.1548 12.9098 15.4545L12.5455 15.5283V15.9V19V19.4545H13H16.5455V20.5455H7.45455V19.4545H11H11.4545V19V15.9V15.5283L11.0902 15.4545C9.60975 15.1548 8.38164 14.1272 7.80908 12.764L7.70733 12.5217L7.4466 12.489C5.19654 12.2066 3.45455 10.3134 3.45455 8V7C3.45455 6.15104 4.15104 5.45455 5 5.45455H7H7.45455V5V3.45455H16.5455V5ZM5 6.54545H4.54545V7V8C4.54545 9.50255 5.51606 10.7661 6.84525 11.2474L7.45455 11.468V10.82V7V6.54545H7H5ZM16.5455 10.82V11.468L17.1547 11.2474C18.4839 10.7661 19.4545 9.50255 19.4545 8V7V6.54545H19H17H16.5455V7V10.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.718e4ced3bc27322b10f003bd324920e.svg";
export { ForwardRef as ReactComponent };